import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';

export const consts = createReqConsts('programs', 'leave', ['INIT']);
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'users',
  slug: [
    { type: 'payload', selector: ['userId'] },
    'patient_programs',
    { type: 'payload', selector: ['programId'] },
  ],
  type: 'delete',
});

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/programs/leaveProgram.js